import { Link } from 'react-router-dom';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-6 py-8 text-center sm:flex-row sm:justify-between sm:text-left">
        <p className="text-sm text-gray-500">
          &copy; {year} Blue Phoenix Designs. All rights reserved.
        </p>
        <div className="flex items-center gap-6 text-sm text-gray-500">
          <Link to="/contact" className="hover:text-phoenix-blue-600">
            Contact
          </Link>
        </div>
      </div>
    </footer>
  );
}
